export enum ExtensionTypeEnum {
  ADD_TIME = 0,
  OVERLAP_TIME = 1,
}
